import React, {lazy} from 'react';
import {createRoot} from 'react-dom/client';
import {useSHCore} from '@hooks/useSHCore';
import {getInitialMeta, getInitialPageState} from "@helpers/HelperInitialPageState";
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import {ContextCartProvider} from "@contexts/ContextCartProvider";
import {ContextTLDProvider} from "@contexts/ContextTLDProvider";
import {ContextNotificationProvider} from "@contexts/ContextNotificationProvider";
import styles from './PageManagedVPSPlans.scss';
import Header from '@components/base/Header/Header';
import Footer from '@components/base/Footer/Footer';
import ManagedVPSPlansHeaderData from '@components/base/Header/data/ManagedVPSPlansHeaderData';
import CharacteristicsE from "@components/blocks/CharacteristicsE/CharacteristicsE";
import ManagedVPSPlansData from "@components/blocks/CharacteristicsE/data/ManagedVPSPlansData";
import MenuBottom from "@components/base/MenuBottom/MenuBottom";

const PageManagedVPSPlans = (props) => {
	useSHCore({props, name: 'PageManagedVPSPlans', isPage: true});

	ManagedVPSPlansData.serviceParams = getInitialPageState()?.componentData?.serviceParams ?? {};

	return (
	  <>
		  <ContextCartProvider>
			  <ContextServicePriceProvider>
				  <ContextTLDProvider>
					  <ContextNotificationProvider color={'color-brand-purple-400'}>
						  <Header data={ManagedVPSPlansHeaderData}/>

						  <main>
							  <CharacteristicsE data={ManagedVPSPlansData} color={'color-brand-purple-400'}/>

							  <MenuBottom color={'color-brand-purple-400'}/>
						  </main>

						  <Footer color={'color-brand-purple-400'}/>
					  </ContextNotificationProvider>
				  </ContextTLDProvider>
			  </ContextServicePriceProvider>
		  </ContextCartProvider>
	  </>
	)
};

const container = document.getElementById(getInitialMeta('pageAppId'));
const root = createRoot(container);
root.render(<PageManagedVPSPlans data={getInitialPageState()}/>);
